module.exports = __webpack_public_path__ + "static/media/torresmo-image.df84fdf4.png";